import { ApiRepository, getLoggerByEnv, RepositoryConfig } from "@ic-anywhere/ic-dal";
import { useAtom, useAtomValue } from "jotai";
import { navigateAsAtom, tokenAtom } from "../state/authentAtoms";
import { isInLanAtom } from "src/state/isInLanAtom";

type UseCrmRepositoryOptions = {
  // if true, don't include impersonatingAs http header in requests
  disableImpersonating?: boolean;
};

export const useRepositoryConfig = (options?: UseCrmRepositoryOptions): RepositoryConfig => {
  const [token] = useAtom(tokenAtom);
  const [navigateAs] = useAtom(navigateAsAtom);
  const isInLan = useAtomValue(isInLanAtom);

  const useImpersonating = options?.disableImpersonating === undefined ? true : !options.disableImpersonating;
  return {
    token,
    impersonatingAs: useImpersonating ? navigateAs?.email : undefined,
    logger: getLoggerByEnv("Events Website" as any),
    isInLan,
  };
};

const useCrmRepository = (options?: UseCrmRepositoryOptions): ApiRepository => {
  const config = useRepositoryConfig(options);
  return ApiRepository.Crm(config);
};

export default useCrmRepository;
